module.exports = __webpack_public_path__ + "portal-static/img/logo2022.2552f098.png";